import * as React from 'react';
import { useState } from 'react';

import { Box, FormControl, ThemeProvider, Typography } from '@mui/material';
import { Formik } from 'formik';

import { BaseButton } from '../../../../../../../../../shared/components/base-button/base-button';
import BaseFormInputField from '../../../../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { useAppDispatch } from '../../../../../../../../../store/hooks';
import { formTheme } from '../../../../../../../../shared/themes/form-theme/form.theme';
import { ReviewModel } from '../../../../../models/review.model';
import { addReply } from '../../../../../thunks/add-reply.thunk';

export const ReplyOnReview = ({ review }: { review: ReviewModel }) => {
  const [shouldReply, setShouldReply] = useState<boolean>(false);
  const [reply, setReply] = useState<string>(review.reply?.reply ?? '');
  const dispatch = useAppDispatch();

  const submitReply = (newReply: string) => {
    setShouldReply(false);
    dispatch(
      addReply({
        reviewId: review.id,
        reply: newReply as string,
      })
    )
      .unwrap()
      .then(r => setReply(r.reply));
  };

  return (
    <Box sx={{ mr: 8 }}>
      <Typography sx={{ mb: 1 }}>{review.review}</Typography>
      {reply && (
        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ fontWeight: 'bold', mr: 1, mb: 1 }}>
            Your reply:
          </Typography>
          <Typography>{reply}</Typography>
        </Box>
      )}
      <ThemeProvider theme={formTheme}>
        {!shouldReply && review.review?.length > 0 && (
          <Typography
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              setShouldReply(true);
            }}
          >
            {reply ? 'Edit Reply' : 'Reply'}
          </Typography>
        )}
        {shouldReply && (
          <Formik
            initialValues={{ reply }}
            onSubmit={values => submitReply(values.reply)}
          >
            {({ values, handleChange, handleSubmit, resetForm }) => (
              <>
                <FormControl>
                  <BaseFormInputField
                    id="reply"
                    label="Your Reply"
                    name="reply"
                    multiline
                    minRows={2}
                    value={values.reply}
                    onChange={handleChange}
                    inputProps={{ maxLength: '500' }}
                  />
                  <Typography
                    className="input-helper-text"
                    sx={{
                      color: theme => theme.palette.appGrey.darkGray,
                      fontSize: '12px',
                    }}
                  >
                    {values.reply.length >= 500
                      ? 'Maximum characters are reached'
                      : 'Maximum 500 characters'}
                  </Typography>
                </FormControl>

                <FormControl
                  classes={{
                    root: 'reply-button-container',
                  }}
                >
                  <Box>
                    <BaseButton
                      className="btn btn-white"
                      onClick={() => {
                        setShouldReply(false);
                        resetForm();
                      }}
                    >
                      <Typography>Cancel</Typography>
                    </BaseButton>

                    <BaseButton
                      className="btn btn-primary"
                      onClick={() => handleSubmit()}
                    >
                      <Typography>Submit</Typography>
                    </BaseButton>
                  </Box>
                </FormControl>
              </>
            )}
          </Formik>
        )}
      </ThemeProvider>
    </Box>
  );
};
